import { getContext } from '@fiverr-private/fiverr_context';

export const isFromMobileAppByQueryParam = () => {
    const { queryParameters } = getContext();

    return queryParameters.from_app === 'true';
};
